import BaseService from "./BaseService";
import { DocumentRequest, DocumentResponse } from "./mappers/DocumentMapper";
import axios from "axios";

class DocumentService extends BaseService {
  constructor() {
    super();
  }

  getDocumentArrayBuffer(url) {
    delete axios.defaults.headers.common["Authorization"];
    return this.get(url, {
      responseType: 'blob',
    })
      .then((response) => response.data)
      .finally(() => {
        let token = localStorage.getItem("token");
        if (token) {
          axios.defaults.headers.common["Authorization"] = "Token " + token;
        }
      });
  }

  createDocument(data) {
    return this.post(`documents/`, DocumentRequest(data)).then((response) => DocumentResponse(response.data));
  }

  createWhistleblowerDocument(data, id) {
    return this.post(`whistleblowerdocuments/${id}`, DocumentRequest(data)).then(
      (response) => DocumentResponse(response.data)
    );
  }

  createExternalDocument(v, token, id, data) {
    return this.post(`external/document/${v}/${token}/${id}/`, DocumentRequest(data))
      .then((response) => DocumentResponse(response.data));
  }

  deleteDocument(id) {
    return this.delete(`documents/${id}/`);
  }
}

export default new DocumentService();
